// extracted by mini-css-extract-plugin
export default {"card":"Card_card__GMSLx","id":"Card_id__ocrqy","balance":"Card_balance__6XpLd","info":"Card_info__dEaPs"};